import React, { useState } from "react";
import { useQuery } from "react-query";

import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../Components/UI/spinner";
import HeaderBar from "../../../Components/UI/headerbar";
import { CuriorStatsConfig, tabs, userShowConfigStats } from "./config";

import StatsCard from "../../../Components/UI/staticsCard";
import { showUser, showUsersStats } from "../../../MyApi/user";
import UserInfo from "../../../Components/users/userInfo";
import UserStatusCard from "../../../Components/users/userStatusCard";
import CuriorsOrders from "../../../Components/curiors/show/curiororders";
import Addresses from "../../../Components/users/address";

const UserShowPage = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("account");
  const { data, isLoading, refetch } = useQuery("showUser", () => showUser(id));
  const { data: userStatsData, isLoading: isLoadingUser } = useQuery(
    ["showUserStats", id],
    () => showUsersStats(id),
  );
  const users = data?.data?.user || {};
  const userStatsApi = userStatsData?.data?.stats || {};
  const {
    avatar,
    status,
    name,
    email,
    id: driverId,
    avg_rate,
    phone,
    address,
    vehicle,
    stats,
    attachments,
  } = users;
  if (isLoading) {
    return <LoadingSpinner />;
  }

  const usersStats = userShowConfigStats(userStatsApi);
  return (
    <div>
      <HeaderBar
        title={"تفاصيل العميل"}
        content={"عرض وإدارة معلومات العميل"}
        isBack={true}
      />

      <UserStatusCard
        avatar={avatar}
        status={status}
        name={name}
        email={email}
        driverId={driverId}
        avg_rate={avg_rate}
        statusApi={status}
        refetch={refetch}
        id={id}
      />

      <div className="row">
        {usersStats.map((stats) => (
          <div className="col">
            <StatsCard {...stats} />
          </div>
        ))}
      </div>

      <div className="card rounded-3 shadow-sm ">
        <div className="card-body">
          <div className="rounded-4 bg-smoke p-2 px-3">
            <ul className="row">
              {tabs.map((tab) => (
                <li
                  className={`col-md text-center p-2 ${
                    activeTab === tab.label ? "bg-white rounded-4" : ""
                  }`}
                  key={tab.id}
                  onClick={() => setActiveTab(tab.label)}
                >
                  {tab.name}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-3">
            {activeTab === "account" && <UserInfo {...users} />}
            {activeTab === "orders" && <CuriorsOrders id={id} isUser={true} />}
            {activeTab === "location" && <Addresses id={id} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserShowPage;
